import { call, put, takeLatest } from 'redux-saga/effects';
import { fetchNotificationUser } from '../../services/notificationUserService';
import { FAILURE, REQUEST, SUCCESS } from '../../utils/actionTypeUtil';
import { pushNotificationMessage } from '../../views/components/Notification';
import { AppAction } from '../app';
import { FETCH_NOTIFICATION_USER } from './notificationUser.actions';

function* fetchNotificationUserListSaga(action: AppAction) {
  try {
    yield put({ type: REQUEST(action.type) });
    const { data, headers } = yield call(fetchNotificationUser, action.payload);
    yield put({ type: SUCCESS(action.type), payload: { data, headers } });
  } catch (error) {
    const errorMessage: string = error.response.data.message;
    yield put({ type: FAILURE(action.type), payload: { errorMessage } });
    yield put(pushNotificationMessage({ message: errorMessage, type: 'error' }));
  }
}

export default function* watchNotificationUser() {
  yield takeLatest(FETCH_NOTIFICATION_USER, fetchNotificationUserListSaga);
}
